import React, { useEffect, useState } from 'react'
import { ConfirmedButton, FormGroupBootstrap } from '../common-components';
import { Field, Form, Formik, useFormikContext } from 'formik';
import { useLogin } from '../reducers';
import { get_domanda_quiz, get_quiz } from '../api/auto-apis';
import { DomandaQuiz, Stage } from '../api/auto-types';
import { DECIMAL_PLACES, login_url } from '../globals';
import { MdMath } from '../components'
import { FormValues } from './IscrizioneStageForm'
import { nice_date } from 'django-rest-react';


const CustomInputForm = ({ field, form, ...props }: any) =>
  <input
    className="form-control"
    style={{ marginBottom: '20px', fontSize: '0.7em' }}
    {...field} {...props}
  />

const udm_swag_ = (udm: string) => (
  <div className="input-group-append">
    <div className="input-group-text">
      <MdMath source={udm} />
    </div>
  </div>
);



interface IProps {
  stage: Stage
  setError: (val: string) => void
}

const PREFIX = "pretest";

type Risposta = FormValues["pretest"]["risposte"][0]

interface RispostaEstesa extends Risposta {
  skip: boolean,
  corretto: boolean,
}

const QuizPreTest = (props: IProps) => {
  const login = useLogin();

  const [quizs, setQuizs] = useState([]);
  const [domande, setDomande] = useState([] as DomandaQuiz[]);
  const { setFieldValue, values } = useFormikContext<FormValues>();

  // @ts-ignore
  const hasOld = !!values?.id &&
    values?.pretest?.risposte?.length > 0;


  useEffect(() => {
    get_quiz().then(quizs => {
      setQuizs(quizs);

      const quiz_giusto = quizs.find(quiz => quiz.id === props.stage.pretest);
      if (!!quiz_giusto) {
        setFieldValue(`${PREFIX}.quiz`, quiz_giusto.id)
        get_domanda_quiz({ quiz: quiz_giusto.id }).then(domande => {
          setDomande(domande)
          setFieldValue(`${PREFIX}.risposte`, domande
            .map(dom => {
              if (hasOld) {
                const found = values.pretest.risposte.find(risp => risp.problema === dom.id)
                if (!!found) return found;
                return {
                  problema: dom.id,
                  valore: 0,
                  valore_exp: 0,
                  skip: true,
                }
              }

              return {
                problema: dom.id,
                valore: 0,
                valore_exp: 0,
                skip: false,
              }
            }))
          props.setError(null);
        })
      }
    })
  }, [])

  if (!login.logged_in) {
    login_url();
  }

  if (!quizs) {
    return <p>Nessun pretest disponibile al momento</p>
  }

  const quiz_giusto = quizs.find(quiz => quiz.stage === props.stage.id);

  const mostra_punteggio = (new Date()).getTime() > new Date(quiz_giusto?.data_risultati_disponibili).getTime() && hasOld;
  return (
    <div>
      <h4 className="page-header">
        Pre-test stage
      </h4>
      {!!quiz_giusto &&
        <>
          <h5><b>Importante</b></h5>
          <p>Puoi consegnare entro {nice_date(quiz_giusto?.fine)} (orario locale del tuo PC)</p>
          <p>Verranno pubblicate le soluzioni e saprai il tuo punteggio/correttezza delle risposte il {nice_date(quiz_giusto?.data_risultati_disponibili)} (orario locale del tuo PC)</p>
          <p>Ogni risposta corretta vale 5 punti, ogni errore -1 e lasciare in bianco 0. Consegnare il test fornisce 20 punti.</p>
          {mostra_punteggio &&
            // @ts-ignore
            <h4><span className="text-info">Punteggio: {values.pretest.punteggio}</span></h4>
          }
        </>
      }
      <FormGroupBootstrap
        name={`${PREFIX}.quiz`} type="select" choices={quizs}
        displayChoice={(q: typeof quizs[0]) => q.titolo}
        disabled
      />

      {!domande && <p>Le domande non sono disponibili</p>}
      {domande.map((domanda, idx) => {
        const udm_swag = udm_swag_(domanda.udm_soluzione);

        let show_giusto = null;
        if (hasOld) {
          const risp = values.pretest.risposte[idx] as unknown as RispostaEstesa;
          if (risp.corretto !== null) {
            if (risp.skip) {
              show_giusto = <i className="mr-3 text-warning fa fa-question" />
            } else {
              show_giusto = risp.corretto ? <i className="mr-3 text-success fa fa-check" /> : <i className="mr-3 text-danger fa fa-times" />
            }
          }
        }

        return (
          <div className={`card px-3 py-3 my-1`} key={domanda.id}>
            <div className="card-title">
              <p>{show_giusto} "{domanda.testo}"</p>
            </div>
            <div className="card-body">
              <FormGroupBootstrap
                name={`${PREFIX}.risposte[${idx}].problema`} type="select"
                choices={domande} displayChoice={(val: DomandaQuiz) => val.nome}
                readOnly disabled
              />
              <FormGroupBootstrap
                type="checkbox"
                name={`${PREFIX}.risposte[${idx}].skip`}
                displayName="Lascia in bianco"
                help_text="Se selezioni questo checkbox, non consegnerai alcuna risposta numerica al quesito"
                disabled={hasOld}
                readOnly={hasOld}
              />
              { // @ts-ignore
                !values?.pretest?.risposte[idx].skip &&
                <div className="row">
                  <div className="col">
                    <FormGroupBootstrap
                      type="number" name={`${PREFIX}.risposte[${idx}].valore`}
                      step={DECIMAL_PLACES}
                      readOnly={hasOld}
                    />
                  </div>
                  <span className="mt-3">✕10</span>
                  <div className="col-sm-3 ml-0">
                    <Field
                      component={CustomInputForm}
                      className="form-control"
                      name={`${PREFIX}.risposte[${idx}].valore_exp`}
                      type="number" step={1}
                      readOnly={hasOld}
                    />
                  </div>
                  {udm_swag}
                </div>
              }

            </div>
          </div>
        )
      })}
    </div>
  )
}


export default QuizPreTest;
